
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useState,useEffect,useMemo,useRef,useCallback, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, BarCharts, ListViewGridComponent, LineChart } from '../../../../components/dashboard';
import { ShowChartFullScr,Loading } from '../../../../common';
import { columnDefs } from '../../../../utils/configs';
import {options_flights} from '../../../../components/dashboard/BarCharts.tsx'
import totalOrders from '../../../../assets/icons/total-orders.svg';
import plus from "../../../../images/icons/plus.png";
import minus from "../../../../images/icons/minus.png";
import widgetIcon from '../../../../assets/icons/widget.svg';
import rubic from '../../../../assets/icons/rubic.svg';
import totalSales from '../../../../assets/icons/total-sales.svg';
import salesGraphIcon from '../../../../assets/icons/sales-growth-chart.svg';
import pieChartIcon from '../../../../assets/icons/pi-chart-sales.svg';
import closeIcon from '../../../../images/icons/Icon2.png';
import usePermissions from '../../../../utils/userPermissions';
import { APIEndpoint } from '../../../../utils/axios';
import {ThemeContext} from '../../../../contexts/themeContext';
import '../../../../assets/styles/styles.scss';
import { updateButtonTxtStatus, getCultureFromLs,storageUtil} from '../../../../utils/commonFunctions';


export const SalesOverviewNewPage = (props) => {
    const { t,ready } = useTranslation();
    const [ sidebar, setSidebar ] = useState(false);
    const [ chartDetails, setChartDetails ]=useState({ show:false, label:"", type:"", data: [], options: [] });
    const [ customizeWidget, setCustomizeWidget ]=useState(false);
    const [warehouseArr,setWareHouseArr]=useState([]);
     const [isExpanded, setIsExpanded] = useState(false);
    const dragItem = useRef(null);
    const timeoutRef = useRef(null);
    const dragOverItem =useRef(null);
    const {themedColor} = useContext(ThemeContext);
    const [userWidgetDetails,setUserWidgetDetails]=useState({});
    const [timeoutDone, setTimeoutDone] = useState(false);
    const [ dataCards, setDataCards] = useState([]);
    const [ widgets, setWidgets ] = useState([]);
    const [ viewId, setViewId ] = useState(null);
    const [countryDetails,setCountryDetails]=useState({});
    const [ userWidgetIds, setUserWidgetIds ] = useState([]);
    const [ notAddedWidgets, setNotAddedWidgets ] = useState([]);
    const [filteredWidgetData,setFilteredWidgetData]=useState([]);
    const [ filtersChartZoom, setFiltersChartZoom ] = useState('');
    const [allWidgetDetails,setAllWidgetDetails]=useState([]);
    const [resetWidgetIds,setResetWidgetIds]=useState([])
    const [listViewColumns, setListViewColumn]=useState(columnDefs);

    const { hasPermission: createWidgets } = usePermissions('create', 'orn:Account:DashboardAccess');
    const { hasPermission: viewWidgets } = usePermissions('view', 'orn:Account:DashboardAccess');

        useEffect( () => {
          getAllWidgetLists();
        setListViewColumn(columnDefs);
    }, []);

    useEffect(() => {
        if(userWidgetDetails && Object.keys(userWidgetDetails).length>0){
         initialWidgetSettings();
         const {widgets}=userWidgetDetails;
         let dataArray=widgets?.filter(s=>s.type==='card')
         setDataCards(dataArray);
        }
    }, [userWidgetDetails,customizeWidget])


    useEffect(() => {
    if (userWidgetDetails && Object.keys(userWidgetDetails).length > 0) {
        TimeOutSuccess();
    }
}, [userWidgetDetails]);


        useEffect(() => {
            if(userWidgetDetails && Object.keys(userWidgetDetails).length>0){
                removeCardWidgets(widgets,true);
                }
            }, [customizeWidget])

        useEffect(() => {
            if(filteredWidgetData){
                setWidgets(widgets?.map(obj => {
                    if (obj.widgetId ===filteredWidgetData?.widgetId ) {
                      return {...filteredWidgetData};
                    }
                    return obj;
                  }));
            }

        }, [filteredWidgetData])

        useEffect(async() => {
            if(userWidgetIds.includes(11) && warehouseArr.length===0){
                getWarehouses();
            }
        }, [userWidgetIds,warehouseArr])

const baseButton = {
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
  transition: 'all 0.3s ease',
  fontSize: '24px',
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '50px',
    right: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    zIndex: 1000,
  },
  secondaryButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    opacity: isExpanded ? 1 : 0,
    transform: isExpanded ? 'translateY(0)' : 'translateY(32px)',
    transition: 'all 0.3s ease-in-out',
    pointerEvents: isExpanded ? 'auto' : 'none',
  },
  secondaryButton: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    transition: 'all 0.2s ease',
    fontSize: '20px',
  },
  button2: {
    backgroundColor: themedColor.background,
  },
  mainButton: {
    ...baseButton,
    backgroundColor: '#70CEEA',
    transform: isExpanded ? 'rotate(45deg)' : 'rotate(0deg)',
  },
  loadingButton: {
    ...baseButton,
    backgroundColor: themedColor.background,
    cursor: 'none', 
    transform: isExpanded ? 'rotate(45deg)' : 'rotate(0deg)',
  },
  icon: {
    width: '24px',
    height: '24px',
  },
};

    const getUserWidgetList=async()=>{
        try {
           const rawId = storageUtil.get('employeeId', 'local');
         const wtId = (typeof rawId === 'string' || typeof rawId === 'number') ? String(rawId) : '';
            const resp = await APIEndpoint.get(`portal/v1/user/${wtId}/widgets`);
            if(resp.success){
                setUserWidgetDetails(resp.data);
                setViewId(resp.data?.viewId);
                removeCardWidgets(resp.data.widgets,true);
                 updateButtonTxtStatus(false, null, 'Apply', { defaultButtonText: 'Apply' });
            }

        }

        catch (error) {
            console.log("Error occured while fetching user widget list:", error?.message );

        }

    }

    const getAllWidgetLists=async()=>{

        try {
             let resp = await APIEndpoint.get(`portal/v1/widget/list/short`);
            if(resp.success){
              resp={data:{viewId:1,widgetIds:resp.data.map(wdt=>wdt.widgetId),widgets:resp.data}}; 
              removeCardWidgets(resp.data.widgets,true);
              setUserWidgetDetails(resp.data);
              setCountryDetails(getCultureFromLs());              
              setAllWidgetDetails(removeCardWidgets(resp.data.widgets,false));
              getUserWidgetList();
              }
            
            }
            catch (error) {
                console.log("Error::::::",error)
            }

    }

  const toggleExpanded = () => {
    customizeView();
    setIsExpanded(!isExpanded);
  };

    const removeCardWidgets=(wGt,def)=>{
        const modWidgets=wGt?.filter(wt=>(wt.widgetId!==12 && wt.widgetId!==13))
        if(Array.isArray(modWidgets) && modWidgets.length>0 && def){
            setWidgets(modWidgets);
        }
        return modWidgets;
    }

const initialWidgetSettings = (widgetCheck=false) => {
    if (userWidgetDetails && Object.keys(userWidgetDetails).length > 0 && Array.isArray(allWidgetDetails) && Array.isArray(widgets))
       {
        if(!widgetCheck){
        setUserWidgetIds(userWidgetDetails.widgetIds);
        }
        const isSameLength = allWidgetDetails.length === widgets.length;
        const notAdded = allWidgetDetails.filter(w=>w.type!=='card').map(widget => ({
            ...widget,
            selected:isSameLength?!widgets.some(wdt => widget.widgetId === wdt.widgetId):widgets.some(wdt => widget.widgetId === wdt.widgetId),
        }));
        setNotAddedWidgets(notAdded);
        displayNotAddedWidgets(notAdded);
    }
};


    const getWarehouses = useCallback(async () => {   
      if(warehouseArr.length>0) return;
        try {
         const resp = await APIEndpoint.get('warehouses');
        if (resp.success && resp.result?.length) {
            setWareHouseArr(resp.result);
        }
        } catch (error) {

        }}
      ,[]) 
   const customizeView = () => {
        setCustomizeWidget(!customizeWidget);
        if(!Object.keys(userWidgetDetails).length){
          getUserWidgetList();
        }
    }

    const handleSort = () => {
        let _componentData = [ ...userWidgetIds ]

        const temp = _componentData[dragItem.current];
        _componentData[dragItem.current] = _componentData[dragOverItem.current];
        _componentData[dragOverItem.current] = temp;

        dragItem.current = null
        dragOverItem.current = null
        setUserWidgetIds(_componentData)
    }

  const onSelectCheckbox = (e) => {
    const widgetId = parseInt(e.target.id);
    setUserWidgetIds(prev => [...prev, widgetId]);

    setResetWidgetIds(prev =>
        prev.includes(widgetId)
            ? prev.filter(id => id !== widgetId)
            : [...prev, widgetId]
    );

    const selectedWidget = notAddedWidgets.find(w => w.widgetId === widgetId);
    if (!selectedWidget) return;

    const updatedWidget = { ...selectedWidget, selected: true };

    setWidgets(prev => {
        const widgetMap = new Map();
        [...prev, updatedWidget].forEach(w => {
            widgetMap.set(w.widgetId, w);
        });
        return Array.from(widgetMap.values());
    });

    setNotAddedWidgets(prev =>
        prev.filter(w => w.widgetId !== widgetId)
    );
};

const onSelectCheckboxRemove = (e) => {
    const widgetId = parseInt(e.target.id);

    setResetWidgetIds(prev =>
        prev.includes(widgetId)
            ? prev.filter(id => id !== widgetId)
            : [...prev, widgetId]
    );

    setUserWidgetIds(prev =>
        prev.filter(id => id !== widgetId)
    );

    setWidgets(prev =>
        prev.filter(widget => widget.widgetId !== widgetId)
    );

    setNotAddedWidgets(prev => {
    const updated = prev.map(widget =>
        widget.widgetId === widgetId
            ? { ...widget, selected: false }
            : widget
    );
    const refArr = new Set();
    return updated.filter(widget => {
        if (refArr.has(widget.widgetId)) return false;
        refArr.add(widget.widgetId);
        return true;
    });
});
};


    const onCloseView=()=>{
        setChartDetails((_prev) => {
            return { ..._prev, show: false }
          })
    }
    const onCloseCard=()=>{
        setChartDetails((_prev) => {
            return { ..._prev, showCard: false }
          })
    }



    const showSidebar = () => {
        setSidebar(!sidebar);
    }

    const resetWidgetView = (e) => {
    if(resetWidgetIds.length){
    let updatedUserWidgetIds = [...userWidgetIds];
    let updatedWidgetNew = [...allWidgetDetails];
    let updatedRemovedWidgetNew = [...allWidgetDetails];

    resetWidgetIds.forEach((wId) => {
      if (!updatedUserWidgetIds.includes(wId)) {
        updatedUserWidgetIds.push(wId);
      } else {
        const index = updatedUserWidgetIds.indexOf(wId);
        if (index !== -1) {
          updatedUserWidgetIds.splice(index, 1);
        }
      }
    });

   setUserWidgetIds(updatedUserWidgetIds);

updatedWidgetNew = updatedWidgetNew?.map((widg) => {
    if (resetWidgetIds.includes(widg.widgetId)) {
      const isWidgetInUser = userWidgetIds.includes(widg.widgetId);
      widg.selected = isWidgetInUser ? true : false;
    }
    return widg;
  });

  updatedRemovedWidgetNew = updatedRemovedWidgetNew.map((widg) => {
    if (resetWidgetIds.includes(widg.widgetId)) {
      const isWidgetInUser = userWidgetIds.includes(widg.widgetId);
      widg.selected = isWidgetInUser ? false : true;
    }
    return widg;
  });

setNotAddedWidgets(updatedRemovedWidgetNew);
setWidgets(updatedWidgetNew);

 setResetWidgetIds([])
 updateButtonTxtStatus(true, e, 'Resetting...', true);
 updateButtonTxtStatus(true, e, 'Reset', false, { defaultButtonText: 'Reset' });
}
    };

    const updateWidgetView = async(e) => {
        updateButtonTxtStatus(true, e, 'Applying...', true);
        setResetWidgetIds([])
        
         const rawId = storageUtil.get('employeeId', 'local');
         const employeeId = (typeof rawId === 'string' || typeof rawId === 'number') ? String(rawId) : '';

        // Call the API with present UserWidgetIds
        APIEndpoint.post('portal/v1/user/' + employeeId + '/widgets', {
            viewId: viewId,
            widgetIds: userWidgetIds
        }).then( resp => {
            updateButtonTxtStatus(true, e, 'Applied', false, { defaultButtonText: 'Apply' });
            getAllWidgetLists();
            setSidebar(!sidebar);
            setViewId(null);
            setCustomizeWidget(!customizeWidget)

        })
        .catch( err => {
            updateButtonTxtStatus(false, e, 'Failed!', false, { defaultButtonText: 'Apply' });
        });
    }

    const setListViewData = (data) => {
        let res;
        if(data){
          res = listViewColumns?.map((c,i)=>{
            const field = Object.keys(data)[i]
            return {...c,field: field, headerName: getHeader(field)}
          })
          //  res = listViewColumns.map( (c,i) => i===0 ? c : (i = Object.keys(data)[i-1], {...c, field: i, headerName: getHeader(i)}));
        }
        return res;
    }



   const getHeader= (s)=>{
        if(s){
            const unCamelCase = s[0].toUpperCase() + s.substring(1).replace(/([A-Z])/g, r => ` ${r}`)
            return unCamelCase;
        }
    }

  const modifyListHeader=(header)=>{
        if(header && header.itemId){
         delete header.itemId;
         return header
        }
        else if(header && header.id){
         delete header.id;
         return header
        }else {
         return header
        }
  }


  const displayNotAddedWidgets=(n)=>{
    let res= n.filter(_=>!_.selected).map((_, index) => {
        return (
            <li className='nav-menu-components text-inactive' key={ index }>
                <div className='checkbox__dashboard'>
                    <input
                        id={ _.widgetId}
                        name={"important"+ _.widgetId}
                        type='checkbox'
                        checked=""
                        onChange={() => {}}
                        className='floatLeft'
                        onClick={(e) => onSelectCheckbox(e)}
                    />
                </div>
                <div id={"important-span" + _.widgetId} className='nav-menu-components-title  floatLeft mt-2'>{ _.widgetName}</div>
            </li>
        );
    })

    return res;
  }

const getFiltersList=(w)=>{
    const {filters}=w;
    let wName={},
     wHouse="",
     weekMonth="";
    if(filters&&filters?.warehouseId){
            wName=warehouseArr?.find(w=>w.id===filters.appliedFilters?.warehouseId)
            wHouse=wName?.value?wName?.value:"";
    }
    if(filters&&filters.sortBy)
    {
        weekMonth=filters.sortBy?filters.sortBy:"";
    }
    if(wName)
    {
        wName=wName?wName:{};
    }

    return [wHouse,weekMonth,wName]
  }

  const barWidgetAmountRep=(w)=>{
    const formatCount = (value) => {
        if (Math.abs(value) >= 1e6) {
          return (value / 1e6).toFixed(0) + 'M';
        } else if (Math.abs(value) >= 1e3) {
          return (value / 1e3).toFixed(0) + 'K';
        } else {
          return value.toFixed(0);
        }
      };
    if (w && w.options && (w.chartType === 'bar' || w.chartType ==='line'|| w.chartType ==='pie')) {
        w.options.scales.y.ticks.callback = function (value) {
              return formatCount(value);
          };

          return w;
        }

      return w;
  }

const handleDragStart = useCallback((index) => {
  dragItem.current = index;
}, []);

function TimeOutSuccess(){
  if(timeoutRef.current){
    clearTimeout(timeoutRef.current)
  }
  setTimeoutDone(false);
  timeoutRef.current=setTimeout(()=>{
   setTimeoutDone(true);
  },1900)
}

const handleDragEnter = useCallback((index) => {
  dragOverItem.current = index;
}, []);
    const handleZoom=(label,data,options=null,salesData=null)=>{
        switch (label) {
            case 'saleReport':
            setChartDetails({show:true,showCard:false,label,type:"pie",data,options})
            break;
            case 'daily':
            setChartDetails({show:true,showCard:false,label,type:"bar",data,options})
            break;
            case 'listView':
            setChartDetails({show:true,showCard:false,label:label,type:"list",data:data,options:options})
            break;
            default:
            setChartDetails({show:false,showCard:true,label,type:"cards",data,options,salesData})
            break;
        }
    }

    const salesAndOrders=(items)=>{
        // eslint-disable-next-line array-callback-return
        const res=items.map((_,index)=>{
    if(_.widgetKey==='orderSalesCurrentFinancialYear'){
    const {orders,sales}=_.datasets
           return(
           <>
      <div className="col-lg-3 card-container-sales-header card-sales full-flex" >
        <div className="card-content2">
          <div>
          Total Sales

          </div>
          <div className="h4 margTop5">
            {countryDetails?.currency?.symbol} {sales}
          </div>
          <div className="dashboard-header-footer ">
          <img className="dashboard-header-main-icon floatRight pb-1" alt="Sales Graph" src={totalSales} />
           
          </div>
        </div>
      </div>

      <div className="col-lg-3 card-container-sales-header card-sales full-flex" >
        <div className="card-content2">
          <div>
            Total Orders
         
          </div>
          <div className="h4 margTop5"> {orders}</div>
          <div className="dashboard-header-footer ">
            <img className="dashboard-header-main-icon floatRight pb-1" alt="Orders Graph" src={totalOrders} />
          </div>
        </div>
      </div>

      </>

      )
}
else if(_.widgetKey==='currentMonthAvgSalesOrders'){
    const {orders,sales}=_.datasets
    return(
    <>

      <div className="col-lg-3 card-container-sales-header card-sales full-flex" >
        <div className="card-content2">
          <div>
          Current Month Sales
           
          </div>
          <div className="h4 margTop5">
            {countryDetails?.currency?.symbol} {sales}
          </div>
          <div className="dashboard-header-footer ">


            <img className="dashboard-header-main-icon floatRight pb-1" alt="Sales Graph" src={salesGraphIcon} />
          </div>
        </div>
      </div>

        {/* current month Orders Card */}
        <div
        className="col-lg-3 card-container-sales-header card-sales full-flex" >
        <div className="card-content2">
          <div>
            Current Month Orders
 
          </div>
          <div className="h4 margTop5"> {orders}</div>
          <div className="dashboard-header-footer ">

            <img className="dashboard-header-main-icon floatRight pb-1" alt="Orders Graph" src={pieChartIcon} />
          </div>
        </div>
      </div>

    </>
    )
    }

          })
          return res;
    }

const notAddedList = useMemo(() => displayNotAddedWidgets(notAddedWidgets), [notAddedWidgets]);
const salesOrdersList = useMemo(() => salesAndOrders(dataCards), [dataCards, countryDetails]);

const renderWidget = (widget) => {
  const widgetAmount=barWidgetAmountRep(widget);
  switch (widget.chartType || widget.type) {
    
        case 'pie': return <div className={`col-sm-1 col-md-2 col-lg-3 ${widgetAmount?.datasets && widgetAmount.datasets[0]?.data?.every(d => d === 0) ? 'card-container3 flex-start' : 'card-container3'}`} key={widget.widgetId}>
        <div className="card-content2 marginHalf">
        <PieChart chartLabel='saleReport' data={widgetAmount} setFilteredWidgetData={setFilteredWidgetData} filtersPie={widget.filters} setFiltersChartZoom={setFiltersChartZoom} handleZoom={handleZoom} />
        </div>
        </div>;
        case 'bar': return <div className={`col-sm-1 col-md-2 col-lg-3 ${widgetAmount?.datasets && widgetAmount.datasets[0]?.data?.every(d => d === 0) ? 'card-container3 flex-start' : 'card-container3'}`} key={widget.id}>
        <div className="card-content2 marginHalf">
        <BarCharts chartLabel='daily'  handleZoom={handleZoom} setFilteredWidgetData={setFilteredWidgetData} setFiltersChartZoom={setFiltersChartZoom} filtersBar={widget.filters} data={widgetAmount} options={widget.options? widget.options: options_flights}/>

        </div>
        </div>;
        case 'line': return  <React.Fragment key={widget.widgetId}> <LineChart
        setFilteredWidgetData={setFilteredWidgetData}
        id={widget?.widgetId}
        filtersLine={widget.filters}
        title={widget?.widgetName} legends={widget?.legends}
        labels={widget?.labels} datasets={widgetAmount?.datasets}
        /></React.Fragment>;
        case 'listView':
           case 'list':
             return  <div className="col-sm-1 col-md-2 col-lg-3 card-container4 sm-scrollbar" key={widget?.widgetId}>
        <div className="card-content2 listGridSection marginHalf">
        <ListViewGridComponent
          id={widget?.widgetId}
          title={widget?.widgetName}
          filtersList={getFiltersList(widget)}
          setFilteredWidgetData={setFilteredWidgetData}
          warehouseArr={warehouseArr}
          rowsData={ widget?.datasets[0]?.items}
          columnDefs={ setListViewData(modifyListHeader(widget?.datasets[0]?.items[0])) }
          handleZoom={handleZoom}
          chartLabel='listView'
        />
        </div>
        </div>
      
        default: return null;
  }
};

    return (
        <>
          <div className="container-fluid dashboard-summary-container sm-scrollbar" id="dashboard-summary-container">
                <div className="row flexRow">
                    <div>
                        <nav className={sidebar ? 'nav-menu active' : 'nav-menu '}>
                            <div className='nav-menu-items widgets-side-menu-container sm-scrollbar'>
                                <div className='nav-menu-header'>
                                    <div className='nav-menu-header-title'>{t('pages.dashboardContent.dashboard.widgetMenuBar.customizeWidget')}<img className="modal__close_icon floatRight mt-1" style={{cursor:'pointer'}} alt='Close' src={closeIcon} onClick={showSidebar} /></div>
                                </div>

                                <div>
                                   { widgets.length>1 ?<div className='nav-menu-subtitle'>{t('pages.dashboardContent.dashboard.widgetMenuBar.dragToReorder')}</div>:<></>}
                                    <ul className='nav-menu-components-box'>
                                    {
                                        userWidgetIds
                                        .map(( _, index) => {
                                            const widget = widgets.find(w => w.widgetId === _ );
                                            let data = null;
                                            if (widget) {
                                                data = (
                                                    <li className='nav-menu-components active-text'
                                                        key={ index }
                                                        draggable
                                                        style={{cursor:'pointer'}}
                                                        onDragStart={() => handleDragStart(index)}
                                                        onDragEnter={() => handleDragEnter(index)}
                                                        onDragEnd={handleSort}
                                                        onDragOver={(e) => e.preventDefault()}
                                                    >
                                                        <div className='checkbox__dashboard'>
                                                            <input
                                                            id={widget.widgetId}
                                                            name={"important"+widget.widgetId}
                                                            type='checkbox'
                                                            checked={true}
                                                            onChange={() => {}}
                                                            className='floatLeft'
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              onSelectCheckboxRemove(e)}}
                                                            />
                                                        </div>
                                                        <div id={"important-span"+widget.widgetId} className='nav-menu-components-title floatLeft mt-2'>{widget.widgetName}</div>
                                                        <div className='drag-reorder-widgets'>
                                                            <img className="icon" alt='widgets' src={rubic} />
                                                        </div>
                                                    </li>
                                                )
                                            }
                                            return data;
                                        })
                                    }
                                    </ul>
                                </div>

                                <div className='mb-4'>
                                    {notAddedWidgets.some(s=>s.selected===false)&&<div className='nav-menu-subtitle'>{t('pages.dashboardContent.dashboard.widgetMenuBar.selectToAdd')}</div>}
                                    <ul className='nav-menu-components-box'>
                                      {notAddedList}
                                    </ul>
                                </div>
                                <hr />
                                <div className="dialog__footer flexRow justifyContentSpaceEvenly mt-4">
                                    <button className={!resetWidgetIds.length?'reset-button-disabled':'reset-button'} disabled={!resetWidgetIds.length} onClick={resetWidgetView}>{t('pages.dashboardContent.dashboard.widgetMenuBar.reset')}</button>
                                  { createWidgets ? <button className="apply-button" onClick={updateWidgetView}>{t('pages.dashboardContent.dashboard.widgetMenuBar.apply')}</button>:<></>}
                                </div>

                            </div>
                        </nav>
                    </div>

                    <div className='scroll-container sm-scrollbar paddingLeft2'>
                    { viewWidgets && salesOrdersList}
                    </div>
                </div>


                <div style={{marginTop:'1.1rem'}} className="row flexRow justifyContentSpaceBetween">
                    {
                       userWidgetIds && userWidgetIds?.map(( _) => {
                        const widget = widgets.find(w => w.widgetId === _);
                        return widget && timeoutDone && renderWidget(widget);
                        })
                    }

                    {(userWidgetDetails && !Object.keys(userWidgetDetails).length)  || !timeoutDone?<>
                        <div className="selectWidgetDashboard flexCol justifyContentSpaceEvenly alignItemsCenter full-flex">
                            <Loading size={"61px"} className={"custom-loading"} />
                            <span style={{ fontSize: "1rem" }}>Loading
                            <div className='loading-dots'>
                                <span className='loaderdots' style={{'--d':'200ms'}}></span>
                                <span className='loaderdots' style={{'--d':'400ms'}}></span>
                                <span className='loaderdots' style={{'--d':'600ms'}}></span>
                                </div></span>
                        </div>
                    </>:userWidgetIds && userWidgetIds.length===2? <>
                        <div className="selectWidgetDashboard flexRow justifyContentSpaceEvenly alignItemsCenter">
                            <p className="alert_error">{t('pages.dashboardContent.dashboard.message.addWidget')}</p>
                        </div>
                    </>:<></>}

                </div>


 <div style={styles.container}>
      {viewId!==null?<div style={styles.secondaryButtonsContainer}>
        <button
          style={{ ...styles.secondaryButton, ...styles.button2 }}
          onClick={showSidebar}
          aria-label="Button 2"
        >
     {!sidebar? <img className = "icon-dashboard-customise"  alt='addWidgets' title={t('pages.dashboardContent.dashboard.header.widgets')} src={plus} />: <img className = "icon-dashboard-customise" alt='cancel' title={"Cancel"} src={minus} />}
        </button>

      </div>:null}

    {userWidgetDetails && (Object.keys(userWidgetDetails).length) && createWidgets && viewId!==null ? <button
        onClick={toggleExpanded}
        style={styles.mainButton}
        aria-label="Toggle widget customization panel"
        aria-expanded={isExpanded}
      >
        <img className="icon" alt='widgets' title={t('pages.dashboardContent.dashboard.widgetMenuBar.customizeWidget')} src={widgetIcon} />
      </button>:<button  disabled={true} style={styles.loadingButton}> 
        <div title="Please wait..." style={{padding:'5px',marginTop:'8px'}}>
          <Loading/>
        </div>
      </button>
      }
    </div>

                </div>
                {
                    chartDetails.show && viewWidgets && <ShowChartFullScr onClose={onCloseView} filtersChartZoom={filtersChartZoom} setFiltersChartZoom={setFiltersChartZoom} chartType={chartDetails.type} chartZoom={chartDetails.show} chartData={chartDetails.data} chartOptions={chartDetails.options}/>
                }
                {
                    chartDetails.showCard && viewWidgets && <ShowChartFullScr onClose={onCloseCard} chartType={chartDetails.type} chartZoom={chartDetails.show} chartData={chartDetails.data} chartLabel={chartDetails.label} chartOptions={chartDetails.options} salesData={chartDetails.salesData}/>
                }
                {
                !ready &&<div className='overlay_hide sub'></div>
                }

        </>

    );
}
